var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0035 12.58C21.8615 12.58 23.3821 11.0593 23.3821 9.20127V2.20742C23.3821 1.30742 22.7282 0.552637 21.8711 0.39502H15.407C14.5499 0.552637 13.896 1.30742 13.896 2.20742V9.20127C13.896 11.0593 15.4167 12.58 17.2746 12.58H20.0035Z",
    fill: "#FFE58A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0721 5.24629H21.2078C21.3433 5.24629 21.4552 5.13433 21.4552 4.99746V2.54082C21.4552 2.40396 21.3433 2.29199 21.2078 2.29199H16.0721C15.9352 2.29199 15.8232 2.40396 15.8232 2.54082V4.99746C15.8232 5.13428 15.9352 5.24629 16.0721 5.24629Z",
    fill: "#EDF4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3495 2.20742V9.20127C22.3495 10.8256 21.1869 12.1915 19.6538 12.5095V12.58H20.0036C21.8615 12.58 23.3822 11.0593 23.3822 9.20127V2.20742C23.3822 1.30742 22.7283 0.552637 21.8712 0.39502H20.8385C21.6942 0.552637 22.3495 1.30747 22.3495 2.20742Z",
    fill: "#FFD772"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.226 2.54082V4.99746C20.226 5.13433 20.114 5.24629 19.9785 5.24629H21.2075C21.343 5.24629 21.4549 5.13433 21.4549 4.99746V2.54082C21.4549 2.40396 21.343 2.29199 21.2075 2.29199H19.9785C20.1154 2.29194 20.226 2.40396 20.226 2.54082Z",
    fill: "#DBEAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8232 8.33603C15.8232 8.86968 16.256 9.30234 16.7882 9.30234C17.3218 9.30234 17.7545 8.86963 17.7545 8.33603C17.7545 7.80239 17.3218 7.37109 16.7882 7.37109C16.2559 7.37109 15.8232 7.80244 15.8232 8.33603Z",
    fill: "#F37C7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5239 8.33603C19.5239 8.86968 19.9566 9.30234 20.4902 9.30234C21.0238 9.30234 21.4552 8.86963 21.4552 8.33603C21.4552 7.80239 21.0239 7.37109 20.4902 7.37109C19.9566 7.37109 19.5239 7.80244 19.5239 8.33603Z",
    fill: "#C3DDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75342 15.247V23.185H5.87266C7.38086 23.185 7.45967 24.4348 9.30381 24.6338H12.7239C11.0692 24.6338 11.0678 22.2878 12.7239 22.2878C11.0692 22.2878 11.0678 19.9404 12.7239 19.9404C11.0692 19.9404 11.0678 17.5943 12.7239 17.5943H16.9776H19.8724C21.5271 17.5943 21.5271 15.2469 19.8724 15.2469H19.6139C19.4923 15.67 19.0997 15.981 18.6393 15.981C18.179 15.981 17.7877 15.67 17.6647 15.2469H11.6249C12.4447 13.6516 11.7618 11.9401 10.801 11.2351C10.3158 10.8798 9.56924 11.036 9.48628 11.8765C9.33975 13.3792 8.84482 14.1589 8.22139 14.593C7.58135 15.0382 6.80581 15.1211 6.12563 15.2469H5.51045H3.75342V15.247Z",
    fill: "#FFEEE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6904 15.8826C11.0264 15.8702 11.4383 15.6476 11.625 15.2467C12.4447 13.6513 11.7618 11.9399 10.801 11.2348C10.3476 10.9031 9.66743 11.0164 9.51123 11.7173C10.7623 12.1638 11.1342 14.0868 10.7582 15.3877C10.6586 15.7292 10.2647 15.8992 10.6904 15.8826Z",
    fill: "#FFDFCF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.626 12.5803V14.9678C17.626 15.0646 17.6398 15.1586 17.6647 15.2471C17.7877 15.6701 18.179 15.9811 18.6393 15.9811C19.0997 15.9811 19.4922 15.6701 19.6139 15.2471C19.6402 15.1586 19.654 15.0646 19.654 14.9678V12.5803V11.0029C19.654 10.8771 19.5503 10.7734 19.4245 10.7734H17.8541C17.7283 10.7734 17.626 10.8771 17.626 11.0029V12.5803H17.626Z",
    fill: "#7E707D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8687 11.0029V12.5803V14.9678C18.8687 15.0646 18.8548 15.1586 18.8286 15.2471C18.7429 15.5429 18.5272 15.7834 18.2466 15.9023C18.3682 15.9535 18.5009 15.9811 18.6392 15.9811C19.0996 15.9811 19.4921 15.6701 19.6138 15.2471C19.6401 15.1586 19.6539 15.0646 19.6539 14.9678V12.5803V12.5098V11.0029C19.6539 10.8771 19.5502 10.7734 19.4244 10.7734H18.6392C18.7649 10.7735 18.8687 10.8771 18.8687 11.0029Z",
    fill: "#6A5D6A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.724 19.9403H16.3999H16.9777C18.6324 19.9403 18.6324 17.5942 16.9777 17.5942H12.724C11.0679 17.5942 11.0692 19.9403 12.724 19.9403Z",
    fill: "#FFDFCF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.724 22.2878H15.8234H16.3999C18.0546 22.2878 18.056 19.9404 16.3999 19.9404H12.724C11.0679 19.9405 11.0692 22.2878 12.724 22.2878Z",
    fill: "#FFDFCF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7239 19.9408H16.3997H16.9775C18.1761 19.9408 18.5065 18.709 17.9688 18.0303C17.8126 18.4409 17.4241 18.7685 16.8062 18.7685H11.4824C11.4824 19.3546 11.8958 19.9408 12.7239 19.9408Z",
    fill: "#FFCEBF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61768 14.723V23.709C1.61768 23.7961 1.68818 23.8666 1.77529 23.8666H4.57329C4.65898 23.8666 4.72949 23.7961 4.72949 23.709V23.1851V15.247V14.723C4.72949 14.6359 4.65898 14.5654 4.57329 14.5654H1.77529C1.68818 14.5654 1.61768 14.6359 1.61768 14.723Z",
    fill: "#F37C7C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7237 22.2878H15.823H16.3995C17.334 22.2878 17.7405 21.5413 17.6202 20.8901C17.4142 21.0961 17.1114 21.2316 16.7133 21.2316H11.4878C11.5389 21.7763 11.9509 22.2878 12.7237 22.2878Z",
    fill: "#FFCEBF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30391 24.6335H12.724C11.9333 24.6335 11.5213 24.0985 11.4854 23.54H10.1458C8.30308 23.3396 8.2229 22.0898 6.7147 22.0898H4.72949V23.1848H5.87275C7.38096 23.1847 7.45977 24.4345 9.30391 24.6335Z",
    fill: "#FFDFCF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1014 24.6336H15.8234C17.4781 24.6336 17.4781 22.2876 15.8234 22.2876H12.724C11.0679 22.2876 11.0693 24.6336 12.724 24.6336H13.1014Z",
    fill: "#FFDFCF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1014 24.6339H15.8234C16.9514 24.6339 17.3109 23.5431 16.8989 22.8491C16.7316 23.2376 16.3515 23.5403 15.757 23.5403H11.4854C11.5213 24.0988 11.9333 24.6338 12.724 24.6338H13.1014V24.6339Z",
    fill: "#FFCEBF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77529 23.8663H4.57329C4.65898 23.8663 4.72949 23.7958 4.72949 23.7086V23.1847V22.188C4.72949 22.2751 4.65898 22.3456 4.57329 22.3456H3.75352H1.77529C1.68818 22.3456 1.61768 22.2751 1.61768 22.188V23.7087C1.61768 23.7958 1.68818 23.8663 1.77529 23.8663Z",
    fill: "#EE6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/diabetes.dc196563e190eb82ef8b957dc68bc21d.svg";
export { ForwardRef as ReactComponent };